import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import { translate as t } from '../../lib/I18n';
import OrderFare from '../../records/order/Fare';

import FareStations from './FareStations';
import Icon from '../general/Icon';
import { AccessibilityCircleIcon } from '../icons/AccessibilityCircleIcon';


class FareSummary extends React.PureComponent {

    static propTypes = {
        orderFare: PropTypes.instanceOf(OrderFare).isRequired,
        isAmended: PropTypes.bool
    };

    static defaultProps = {
        isAmended: false
    };

    render() {
        const {
            hasMatchingPAJourney,
            orderFare
        } = this.props;

        return (
            <div className="fare-summary padding-bottom--sm">
                <Row>
                    <Col xs={ 12 } md={ 6 } lg={ 6 }>
                        {hasMatchingPAJourney && <AccessibilityCircleIcon />}
                        <FareStations
                            origin={ orderFare.origin }
                            destination={ orderFare.destination }
                            isReturn={ orderFare.isReturn() }/>
                    </Col>
                    <Col xs={ 12 } md={ 6 } lg={ 6 } className="text-weight--normal ticket-type">
                        { orderFare.getName() }&nbsp;
                        { orderFare.isGroupSave() && t('order.summary.groupSave') }
                    </Col>
                </Row>
                {orderFare.hasCountedPlaceWarning() && (
                    <Row>
                        <Col xs={ 12 } className="fare-summary__warning text-sm">
                            <Icon inline icon="warning" aria-hidden="true" />
                            &nbsp;
                            {t('journey.warnings.hasCountedPlace')}
                        </Col>
                    </Row>
                )}
                { orderFare.hasRefundedTickets() && !this.props.isAmended &&
                    <Row>
                        <Col lg={ 6 } md={ 6 } xs={ 12 } className="refunded pull-right">
                            <span className="alert-success text-light pull-right">
                                { t('account.orders.refund.ticket.refunded') }
                            </span>
                        </Col>
                    </Row>
                }
            </div>
        );
    }
}

export default FareSummary;



// WEBPACK FOOTER //
// ./src/components/checkout/FareSummary.js